import { VisitanteDTO } from './visitanteDTO.model';
import { TurnoUACModel } from './turnoUAC.model';
import { stringify } from 'querystring';

export class TurnoGeneradoModel {
    public visitanteDTO: VisitanteDTO;
    public turnoDTO: TurnoUACModel;
    public foto: string;

    constructor(visitanteDTO: VisitanteDTO, turnoDTO: TurnoUACModel){
        this.visitanteDTO = visitanteDTO;
        this.turnoDTO = turnoDTO;
    }
 
}
